import { Outlet, Navigate } from "react-router";
import { useAuth } from "../context/AuthContext";

function PublicRoutes() {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Navigate to="/dashboard" /> : <Outlet />;
}

export default PublicRoutes;
